const ENDPOINT = 'POSTbetaUser';
function postBetaUser(gateway, params) {
    return gateway.post(postBetaUser.endpoint, params);
}
postBetaUser.endpoint = ENDPOINT;

export { postBetaUser as default };
//# sourceMappingURL=postBetaUser.js.map
